import "./_state-message-box.scss";

import {ReactComponent as NotFoundIcon} from "../../core/ui/icon/Close_Thick.svg";

import classNames from "classnames";
import {Fragment} from "react";

import Loading from "../loading/Loading";

interface StateMessageBoxProps {
  state: "error" | "loading" | "empty";
  message?: string;
  customClassName?: string;
}

function StateMessageBox({state, message, customClassName}: StateMessageBoxProps) {
  return (
    <div
      className={classNames(
        "is-centered",
        "is-flex-column",
        "typography--body",
        "is-semi-bold-text",
        "color--text-gray-lighter",
        "state-message-box",
        customClassName
      )}>
      {renderContent()}
    </div>
  );

  function renderContent() {
    let stateMessage = <p>{message || "There is nothing to display"}</p>;

    switch (state) {
      case "loading":
        stateMessage = <Loading message={message} />;
        break;

      case "empty":
        stateMessage = (
          <Fragment>
            <div className={"is-centered state-message-box__not-found-icon"}>
              <NotFoundIcon />
            </div>

            <p className={"state-message-box__message"}>
              {message || "Something unexpected has occured"}
            </p>
          </Fragment>
        );
        break;

      case "error":
        stateMessage = (
          <Fragment>
            <div className={"is-centered state-message-box__not-found-icon"}>
              <NotFoundIcon />
            </div>

            <p className={"state-message-box__message"}>
              {message || "Something unexpected has occured"}
            </p>
          </Fragment>
        );
        break;

      default:
        break;
    }

    return stateMessage;
  }
}

export default StateMessageBox;
